import { isIsoDateTime, get12HourTime, getEmpty12HoursTime } from '../../utils/dateTime';

function normalizeTime(time) {
  if (!time) {
    return getEmpty12HoursTime().toTimeString();
  }

  const timePart = time.split('T')[0];

  // Get the first two characters of the time part
  const isEmptyDate = timePart === '1970-01-01';

  if (isEmptyDate) {
    return '';
  }

  if (isIsoDateTime(time)) {
    return get12HourTime(time).toTimeString();
  }

  return time;
}

const UserPreferences = ({
  userPreferenceId,
  userId,
  division,
  readyTime,
  closingTime,
  fromContactId,
  toContactId,
  overrideContactId,
  shipperPostalCode,
  shipperName,
  consigneePostalCode,
  billToAccountNumber,
  isPickupScheduled,
  serviceType,
  brokerName,
  brokerEmail,
  brokerTelephone,
  overrideConsigneeAddress,
  customizeManageOrders,
}) => ({
  userPreferenceId,
  userId,
  division,
  readyTime: normalizeTime(readyTime),
  closingTime: normalizeTime(closingTime),
  fromContactId,
  toContactId,
  overrideContactId,
  overrideConsigneeAddress,
  shipperPostalCode,
  shipperName,
  consigneePostalCode,
  billToAccountNumber,
  isPickupScheduled,
  serviceType,
  brokerName,
  brokerEmail,
  brokerTelephone,
  customizeManageOrders,
});

export default UserPreferences;
